import { ReceptionListItem } from "./interfaces";

export const receptionWithPackageVariance = (reception: ReceptionListItem) => {
  return (
    reception.BoxesQuantity !== reception.BoxesReceived &&
    reception.Status >= 60 &&
    reception.Status < 99
  );
};
